<template>
  <div v-if="privacy" class="max-w-6xl mx-auto my-0">
    <PageHeader v-if="!isMobile" :title="'Privacy'" :link="{ path: '/', label: 'EER' }" />
    <div class="p-4">
      <h1 :class="isMobile ? 'mt-20' : 'mt-24'">Privacy</h1>
      <br/>
      <div v-html="privacy.text" />
    </div>
    <PageFooter />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PageHeader from '@/components/PageHeader'
import PageFooter from '@/components/PageFooter'

export default {
  name: 'Privacy',

  metaInfo () {
    return {
      title: 'Privacy'
    }
  },

  components: {
    PageHeader,
    PageFooter
  },

  computed: {
    ...mapState(['privacy', 'isMobile']),
  },

  mounted () {
    this.$store.dispatch('getPrivacy')
  }
}
</script>
